import { Link } from "gatsby"
import React, { memo, useState } from "react"
import Fade from "react-reveal/Fade"
import SVGIcon from "./common/SVGIcon"
import CheckLinkDomain from "./utility/current_domain"

const NavbarDropdown = props => {
  const { navigationLinks } = props.data
  const [subFeaturesIndex, setSubFeaturesIndex] = useState("Features")

  const FadeChildren = props => {
    const { children } = props
    return <Fade>{children}</Fade>
  }

  const AllFeatures = ({ data }) => {
    const PsaRmm = data?.featureNavigationLinks.slice(0, 2)
    const Others = data?.featureNavigationLinks.slice(2)

    return (
      <div className='d-flex all-features justify-content-between'>
        <div className='d-flex gap-24 psa-rmm '>
          {PsaRmm?.map(item => {
            return (
              <div className='w-50'>
                <Link
                  to={item?.link}
                  target={CheckLinkDomain(item?.link) ? "_self" : "_blank"}
                  className='d-flex gap-24 align-items-center mb14 feature-heading'
                >
                  <p className='fw-800 p-16 value-heading font-zodiak m-0'>
                    {item?.heading}
                  </p>
                  <SVGIcon
                    name='hypertext-arrow-right'
                    className='arrow-right'
                  />
                </Link>
                {item?.featureNavigationLinks?.map(features => {
                  return (
                    <Link
                      to={features?.link}
                      target={
                        CheckLinkDomain(features?.link) ? "_self" : "_blank"
                      }
                    >
                      <div className='d-flex align-items-center gap-16 icon-text text-deep-purple position-relative'>
                        <div className='icon-wrapper'>
                          <img
                            className='icon w-100'
                            src={features?.icon?.url}
                            alt='icon'
                          />
                        </div>

                        <p className=' m-0 tag-feature'>{features?.heading}</p>
                        {features?.isNew === "Yes" && (
                          <p className='tag position-absolute m-0'>NEW</p>
                        )}
                      </div>{" "}
                    </Link>
                  )
                })}
              </div>
            )
          })}
        </div>
        <div className='d-flex gap-16 flex-column justify-content-center others'>
          {Others?.map(item => {
            return (
              <div>
                <Link
                  to={item?.link}
                  target={CheckLinkDomain(item?.link) ? "_self" : "_blank"}
                >
                  <div className='d-flex align-items-center gap-8 position-relative card-box'>
                    <div className='icon-wrapper'>
                      <img
                        className='icon w-100'
                        src={item?.icon?.url}
                        alt='icon'
                      />
                    </div>
                    <p className='p-15-13 text-deep-purple m-0'>
                      {item?.heading}
                    </p>
                  </div>
                </Link>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  const setPageId = childFooterLink => {
    if (childFooterLink) {
      console.log("childFooterLink ", childFooterLink)
      sessionStorage.setItem("SuperPageSectionID", childFooterLink)
    }
  }
  const ByValues = ({ data }) => {
    return (
      <div className='d-flex flex-wrap gap-16 w-100 justify-content-between'>
        {data?.map(item => {
          return (
            <div className='width-32-percent'>
              <p
                className={`p-16 intra-heading fw-800 font-zodiak  ${
                  item?.heading === "NO HEADING" ? "fade-out-effect" : ""
                }`}
              >
                {item?.heading}
              </p>
              {item?.featureNavigationLinks?.map(features => {
                return (
                  <Link
                    to={features?.link}
                    target={
                      CheckLinkDomain(features?.link) ? "_self" : "_blank"
                    }
                    onClick={() => setPageId(features?.childFooterLink)}
                  >
                    <div className='d-flex align-items-center gap-16 icon-text intra-icon-text text-deep-purple position-relative'>
                      <div className='icon-wrapper intra-icon-wrapper'>
                        <img
                          className='icon w-100'
                          src={features?.icon?.url}
                          alt='icon'
                        />
                      </div>

                      <p className='intra-tag-feature m-0'>
                        {features?.heading}
                      </p>
                      {features?.isNew === "Yes" && (
                        <p className='tag position-absolute m-0'>NEW</p>
                      )}
                    </div>
                  </Link>
                )
              })}
            </div>
          )
        })}
      </div>
    )
  }

  const BottomLinks = () => {
    return (
      <div className='bottom-links d-flex gap-8 align-items-center'>
        <Link to='/signup' className='icon-text bottom-text'>
          <p className='p12 m-0 text-deep-purple'>TRY NOW FOR FREE</p>
        </Link>
        <div className='vert-line'></div>
        <Link to='/demo' className='icon-text bottom-text'>
          <p className='p12 m-0 text-deep-purple'>BOOK A DEMO</p>
        </Link>
        <div className='vert-line'></div>
        <Link to='/contact-us' className='icon-text bottom-text'>
          <p className='p12 m-0 text-deep-purple'>TALK TO SALES</p>
        </Link>
      </div>
    )
  }

  switch (props.data.name) {
    case "Why SuperOps": {
      return (
        <div className='navbar-why-superops-wrapper'>
          <p className='p20 fw-800 font-zodiak text-center mb30 text-deep-purple'>
            {props?.data?.where}
          </p>
          <div className='d-flex gap-24 justity-content-between '>
            {navigationLinks?.map(item => {
              if (item?.link) {
                return (
                  <Link to={item?.link}>
                    <div className='box h-100 dynamic d-flex justify-content-between flex-column'>
                      <div className='top h-100 d-flex justify-content-between flex-column'>
                        <div
                          className='icon-wrapper mb30 br10'
                          // css={css`
                          //   background: linear-gradient(
                          //     90deg,
                          //     ${item?.iconBgColor?.css} -9.17%,
                          //     rgba(255, 255, 255, 0) 100%
                          //   );
                          // `}
                        >
                          <img
                            className='icon w-100'
                            src={item?.icon?.url}
                            alt='icon'
                          />
                        </div>
                        <p className='p15 fw-800 mb14 font-zodiak text-deep-purple'>
                          {item?.heading}
                        </p>
                        <p className='p11 m-0 text-deep-purple'>
                          {item?.childFooter}
                        </p>
                      </div>
                      <div className='bottom'>
                        <p className='p13 m-0 text-center'>{item?.subText}</p>
                      </div>
                    </div>
                  </Link>
                )
              } else {
                return (
                  <div className='box constant prelative'>
                    <div className='white-bg'>
                      <div className='image-wrapper mb15 mx-auto'>
                        <img src={item?.image?.url} className='w-100' />
                      </div>
                      <p className='p-16-24 fw-800 font-zodiak m-0 text-center'>
                        {item?.heading}
                      </p>
                      <p className='p-16-24 fw-800 font-zodiak pink-yellow-gradient m-0 text-center'>
                        {item?.subText}
                      </p>
                    </div>
                    <div className='position-absolute bg-color-card'></div>
                  </div>
                )
              }
            })}
          </div>
        </div>
      )
    }
    case "Products": {
      const LeftBar = navigationLinks?.filter(
        _ =>
          _?.heading?.toLowerCase() !== "featured" &&
          _?.heading !== "SEE ALL INTEGRATIONS"
      )
      const Featured = navigationLinks?.filter(
        _ => _?.heading?.toLowerCase() === "featured"
      )
      const AllIntegrations = navigationLinks?.filter(
        _ => _?.heading === "SEE ALL INTEGRATIONS"
      )
      return (
        <>
          <div className='navbar-products-wrapper d-flex'>
            <div className='left'>
              {LeftBar?.map((item, idx) => {
                return (
                  <div
                    className={`bar  d-flex align-items-center justify-content-between cursor-pointer ${
                      item?.heading === subFeaturesIndex ? "active" : ""
                    }`}
                    onClick={() => setSubFeaturesIndex(item?.heading)}
                    style={{ marginBottom: "7px" }}
                  >
                    <p className={`m-0 p-14 left-tag fw-500`}>
                      {item?.heading}
                    </p>
                    <SVGIcon
                      name='hypertext-arrow-right'
                      className='arrow-right'
                    />
                  </div>
                )
              })}
            </div>
            <div className='right'>
              <div className='top d-flex overflow-hidden'>
                <div
                  className={`sub-contents ${
                    subFeaturesIndex === "Integrations"
                      ? "sub-contents-integration"
                      : ""
                  }`}
                >
                  <FadeChildren>
                    {subFeaturesIndex === "Features" ? (
                      <AllFeatures data={LeftBar[0]} />
                    ) : subFeaturesIndex === "By value" ? (
                      <ByValues data={LeftBar[2]?.featureNavigationLinks} />
                    ) : (
                      <ByValues data={LeftBar[1]?.featureNavigationLinks} />
                    )}
                  </FadeChildren>
                </div>
                <div
                  className={`featured ${
                    subFeaturesIndex === "Integrations"
                      ? "featured-integration"
                      : ""
                  }`}
                >
                  {subFeaturesIndex === "Integrations" ? (
                    <div className='all-integration'>
                      <Link
                        to={AllIntegrations?.[0]?.link}
                        className='d-flex flex-column h-100 justify-content-between'
                      >
                        <img
                          src={AllIntegrations?.[0]?.image?.url}
                          className='w-100'
                        />
                        <p className='p13 word w-100 m-0 text-center'>
                          {AllIntegrations?.[0]?.heading}
                        </p>
                      </Link>
                    </div>
                  ) : (
                    <>
                      <p className='fw-600 featured-title p10 mb8'>
                        {Featured?.[0]?.heading}
                      </p>
                      <div className={`overflow-hidden br10`}>
                        <Link
                          to={Featured?.[0]?.link}
                          // target={
                          //   CheckLinkDomain(Featured?.[0]?.link)
                          //     ? "_self"
                          //     : "_blank"
                          // }
                        >
                          <img
                            src={Featured?.[0]?.image?.url}
                            className='w-100 image'
                          />
                        </Link>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className='bottom d-flex justify-content-end'>
                <BottomLinks />
              </div>
            </div>
          </div>
        </>
      )
    }
    case "Resources":
      const LeftBar = navigationLinks?.filter(abc => abc.heading !== "FEATURED")
      return (
        <>
          <div className='navbar-resources-wrapper'>
            <div className='top d-flex'>
              <div className='left-side'>
                <ByValues data={LeftBar} />
              </div>
              <div className='right-side'>
                {navigationLinks
                  ?.filter(abc => abc.heading === "FEATURED")
                  .map((item, idx) => {
                    return (
                      <div className=''>
                        <p className='featured-title resource-featured p12 fw-bold'>
                          {item.heading}
                        </p>
                        <div className={`overflow-hidden br10`}>
                          <Link
                            to={item.link}
                            target={
                              CheckLinkDomain(item.link) ? "_self" : "_blank"
                            }
                          >
                            <img src={item.image.url} className='w-100 image' />
                          </Link>
                        </div>
                      </div>
                    )
                  })}
              </div>
            </div>
            <div className='bottom d-flex justify-content-end'>
              <BottomLinks />
            </div>
          </div>
        </>
      )
    case "Pricing": {
      return (
        <div className='pricing-drpdown d-flex flex-column gap-12'>
          {navigationLinks.map(item => {
            return (
              <Link to={item.link}>
                <p className='p-14 fw-500 m-0 icon-text text-deep-purple'>
                  {item.heading}
                </p>
              </Link>
            )
          })}
        </div>
      )
    }
    case "Solutions": {
      return (
        <div className='solutions-drpdown'>
          {navigationLinks.map(item => {
            return (
              <Link to={item.link}>
                <div className='icon-text d-flex align-items-center'>
                  <div className='d-flex simple-solution align-items-center'>
                    <div className='position-relative'>
                      <p className='solution-title fw-800 font-zodiak'>
                        {item.heading}
                      </p>
                      <p className='solution-subtext text-deep-purple mb-0'>
                        {item.subText}
                      </p>
                    </div>
                  </div>

                  <div className='solution-icon-wrapper'>
                    <img src={item.icon.url} className='w-100' />
                  </div>
                </div>
              </Link>
            )
          })}
        </div>
      )
    }
    case "Marketplace": {
      const LeftBar = navigationLinks?.filter(abc => abc.heading !== "FEATURED")
      const AllIntegration = LeftBar.slice(-1)

      return (
        <div className='navbar-marketplace-wrapper'>
          <div className='top d-flex'>
            <div className='left-side d-flex gap-20'>
              <div className='single-integration'>
                <ByValues data={LeftBar.slice(0, -1)} />
              </div>
              <div className='all-integration'>
                <Link
                  to={AllIntegration?.[0]?.link}
                  className='d-flex flex-column h-100 justify-content-between'
                >
                  <img
                    src={AllIntegration?.[0]?.image?.url}
                    className='w-100'
                  />
                  <p className='p13 word w-100 m-0 text-center'>
                    {AllIntegration?.[0]?.heading}
                  </p>
                </Link>
              </div>
            </div>
            <div className='right-side'>
              {navigationLinks
                ?.filter(abc => abc.heading === "FEATURED")
                .map((item, idx) => {
                  return (
                    <div className=''>
                      <p className='featured-title mb8 p10 fw-bold'>
                        {item.heading}
                      </p>
                      <div className={`overflow-hidden br10`}>
                        <Link
                          to={item.link}
                          target={
                            CheckLinkDomain(item.link) ? "_self" : "_blank"
                          }
                        >
                          <img src={item?.image?.url} className='w-100 image' />
                        </Link>
                      </div>
                    </div>
                  )
                })}
            </div>
          </div>
          <div className='bottom d-flex justify-content-end'>
            <BottomLinks />
          </div>
        </div>
      )
    }
    default: {
      return <></>
    }
  }
}

export default memo(NavbarDropdown)
